module.exports = __webpack_public_path__ + "img/Fresh-shrimp.04fc142c.jpg";